module.exports = __webpack_public_path__ + "static/media/cacKids.c672fb94.jpg";